import React from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";

import { Home, Projects } from "./views";
import {
  CS300,
  CS537,
  CS540,
  CS564,
  CS571,
  CS585,
  CS639,
  CS640,
  DependencyChecker,
  FitnessTrackerAPI,
  FitnessTrackerApp,
  HopeIslandApp,
  HopeIslandWeb,
  IndoorTracking,
  LaxisApp,
  MovieDB,
  Portfolio,
  QuizGenerator,
  RNAudioPlayer,
  USCFilmsAPI,
  USCFilmsIOS,
  USCFilmsWeb,
  UWCourseSearch,
  WeWish,
  WishShopChatBot,
} from "./projects";

const routes = [
  { name: "Home", path: "/", component: Home },
  { name: "Projects", path: "/projects", component: Projects },
  {
    name: "Introduction to Java and OOP",
    path: "/projects/introduction-to-java-and-oop",
    component: CS300,
  },
  {
    name: "Introduction to Operating Systems",
    path: "/projects/introduction-to-operating-systems",
    component: CS537,
  },
  {
    name: "Introduction to Artificial Intelligence",
    path: "/projects/introduction-to-artificial-intelligence",
    component: CS540,
  },
  {
    name: "Introduction to Database Systems",
    path: "/projects/introduction-to-database-systems",
    component: CS564,
  },
  {
    name: "Introduction to Web Technologies",
    path: "/projects/introduction-to-web-technologies",
    component: CS571,
  },
  {
    name: "Applications of Database Systems",
    path: "/projects/applications-of-database-systems",
    component: CS585,
  },
  {
    name: "Introduction to UX Design",
    path: "/projects/introduction-to-ux-design",
    component: CS639,
  },
  {
    name: "Introduction to Computer Networks",
    path: "/projects/introduction-to-computer-networks",
    component: CS640,
  },
  {
    name: "Dependency Checker",
    path: "/projects/dependency-checker",
    component: DependencyChecker,
  },
  {
    name: "Fitness Tracker Backend",
    path: "/projects/fitness-tracker-backend",
    component: FitnessTrackerAPI,
  },
  {
    name: "Fitness Tracker Mobile App",
    path: "/projects/fitness-tracker-mobile-app",
    component: FitnessTrackerApp,
  },
  {
    name: "Hope Island",
    path: "/projects/hope-island-app",
    component: HopeIslandApp,
  },
  {
    name: "Hope Island Website",
    path: "/projects/hope-island-website",
    component: HopeIslandWeb,
  },
  {
    name: "Indoor Tracking",
    path: "/projects/indoor-tracking",
    component: IndoorTracking,
  },
  { name: "Laxis App", path: "/projects/laxis-app", component: LaxisApp },
  { name: "The Movie DB", path: "/projects/the-movie-db", component: MovieDB },
  {
    name: "Yingjie's Portfolio",
    path: "/projects/yingjies-portfolio",
    component: Portfolio,
  },
  {
    name: "Quiz Generator",
    path: "/projects/quiz-generator",
    component: QuizGenerator,
  },
  {
    name: "RN Audio Player",
    path: "/projects/react-native-audio-player",
    component: RNAudioPlayer,
  },
  {
    name: "USC Films Backend",
    path: "/projects/usc-films-backend",
    component: USCFilmsAPI,
  },
  {
    name: "USC Films iOS App",
    path: "/projects/usc-films-ios-app",
    component: USCFilmsIOS,
  },
  {
    name: "USC Films Web App",
    path: "/projects/usc-films-web-app",
    component: USCFilmsWeb,
  },
  {
    name: "Projects",
    path: "/projects/uw-course-search-web-app",
    component: UWCourseSearch,
  },
  {
    name: "UW Course Search Web App",
    path: "/projects/wewish",
    component: WeWish,
  },
  {
    name: "WiscShop ChatBot",
    path: "/projects/wiscshop-chatbot",
    component: WishShopChatBot,
  },
];

function App() {
  return (
    <Router>
      <Switch>
        {routes.map((route) => (
          <Route
            key={route.name}
            exact
            path={route.path}
            component={route.component}
          />
        ))}
      </Switch>
    </Router>
  );
}

export default App;
